export const loginAdmin = 'admin/loginAdmin'
export const getUser = 'admin/getUser'
export const getRegistrationUser = 'admin/getRegistrationUser'
export const getUserApplicationList = 'users/getUserApplicationList'
export const userApplicationApprove = 'users/userApplicationApprove'
export const newRegistarionApprove = 'admin/newRegistarionApprove'
export const toggleUserStatus = 'admin/toggleUserStatus'
export const getAdminInterestCategoryList =
  'category/getAdminInterestCategoryList'
export const toggleInterestCategoryStatus =
  'category/toggleInterestCategoryStatus'
export const getCategoryWiseInterestList =
  'category/getCategoryWiseInterestList'
export const deleteInterestCategory = 'category/deleteInterestCategory'
export const createInterestCategory = 'category/createInterestCategory'
export const editInterestCategory = 'category/editInterestCategory'
export const getAdminCategoryWiseInterest =
  'category/getAdminCategoryWiseInterest'
export const createCategoryWiseInterest = 'category/createCategoryWiseInterest'
export const toggleCategoryWiseInterest = 'category/toggleCategoryWiseInterest'
export const deleteCategoryWiseInterest = 'category/deleteCategoryWiseInterest'
export const editCategoryWiseInterest = 'category/editCategoryWiseInterest'
export const getUserDetails = 'admin/getUserDetails'
export const getUserMerchandise = 'admin/getUserMerch'
export const toggleStatus = 'admin/toggleMerchStatus'
export const userCheckInEvent = 'admin/userCheckInEvent'
export const userAttendEventList = 'admin/userAttendEventList'
export const AttendEventList = 'admin/AttendEventList'
export const transferEvent = 'admin/transfer-event'
export const CheckedAllEventList = 'admin/CheckedAllEventList'
export const deleteEventMedia = 'artrunner/deleteEventMedia'
export const getUserEvent = 'admin/getUserEvent'
export const admin_toggleEventStatus = 'admin/toggleEventStatus'
export const getAdminEventTypes = 'artrunner/getAdminEventTypes'
export const geteditEventType = 'artrunner/editEventType'
export const getcreateEventType = 'artrunner/createEventType'
export const toggleEventTypeStatus = 'artrunner/toggleEventTypeStatus'
export const deleteEventType = 'artrunner/deleteEventType'
export const getAllEvent = 'admin/getAllEvent'
export const getAllMasterEvent = 'admin/getAllMasterEvent'
export const changeMasterEvent = 'admin/change-master-event'
export const getAdminAllEvent = 'admin/getAdminAllEvent'
export const getUserArtProject = 'admin/getUserArtProject'
export const toggleArtProjectStatus = 'admin/toggleArtProjectStatus'
export const userAchievementsEvent = 'admin/userAchievementsEvent'
export const toggleEventStatus = 'admin/toggleEventStatus'
export const getEventDetails = 'admin/getEventDetails'
export const admin_getUserArtLog = 'admin/getUserArtLog'
export const admin_getArtists_count = 'admin/getArtists'
export const admin_get_ArtLover = 'admin/getArtLover'
export const adminGetArtRunner = 'admin/getArtRunner'
export const editArtRunnerEvent = 'artrunner/editArtRunnerEvent'
export const adminGetDashboardEventCount = 'admin/getDashboardEventCount'
export const adminChangePassword = 'admin/changePassword'
export const adminToggleFeaturedUser = 'admin/toggleFeaturedUser'
export const userArtistList = 'users/artistList'
export const getEventRetainableSettings = 'artrunner/getEventRetainableSettings'
export const usersForgotPassword = 'users/forgotPassword'
export const userResetPassword = 'users/resetPassword'
export const updateUserProfile = 'users/updateUserProfile'
export const searchUser = 'admin/searchUser'

export const getReferralHistory = 'admin/get-referral-history'

export const searchInterestCategory = 'category/searchInterestCategory'
export const searchCategoryWiseInterest = 'category/searchCategoryWiseInterest'
export const searchEvent = 'admin/searchEvent'
export const searchMasterEvent = 'admin/searchMasterEvent'
export const searchSubmitEvent = 'admin/searchSubmitEvent'
export const searchAdminEvent = 'admin/searchAdminEvent'
export const getWithOutCheckInEvent = 'admin/getWithOutCheckInEvent'
export const createArtRunnerEvent = 'artrunner/createArtRunnerEvent'
export const toggleEventFeatured = 'admin/toggleEventFeatured'
export const adminCreateAchievement = 'admin/createAchievement'
export const adminGetAchievement = 'admin/getAchievement'
export const adminDeleteAchievement = 'admin/deleteAchievement'
export const adminToggleAchievementStatus = 'admin/toggleAchievementStatus'
export const allUserList = 'users/allUserList'
export const userArtistTypes = "users/user-artist-types";
export const addUserArtistType = "users/addUserArtistType";
export const statusChangeArtistTags = "users/status-change-artist-types";
export const deleteArtistTypes = "users/delete-artist-types";


export const addCheckIn = "users/addAdminCheckIn";
export const subscriptionGetPlan = "admin/subscription/get-plan";
export const subscriptionCreatePlan = "admin/subscription/create-plan";
export const subscriptionEditPlan = "admin/subscription/edit-plan";
export const subscriptionUpdatePlanStatus = "admin/subscription/update-plan-status";
export const ambassadorRequests = "admin/ambassador/requests";
export const ambassadorAssignByDirectAdmin = "admin/ambassador/assign-by-direct-admin";
export const ambassadorCancelAdminDirectAmbassador = "admin/ambassador/cancel-admin-direct-ambassador";
export const getUserActiveSubscriptionPlan = "admin/get-user-active-subscription-plan";
export const ambassadorApproveRejectRequests = "admin/ambassador/approve-reject-requests";
export const ambassadorCancelAmbassador = "admin/ambassador/cancel-ambassador";
export const upgradeUserSubscription = "admin/upgrade-user-subscription"

export const getActivatedPlan = "admin/subscription/get-activated-plan";
export const getSubscriptionPlanHistory = "admin/subscription/plan-history";
export const freePlanUpgraded = "admin/subscription/free-plan-upgrade";
export const getAllExpieredPlanHistory = "admin/subscription/all-expiered-plan-history";
export const getKpiTracking = "admin/ambassador/kpi/tracking";
export const getKpiUserHistory = "admin/ambassador/kpi/history";
export const getWalletFunds = "wallet/get-wallet-fund-history";
export const getArtrunerWallet = "wallet/get-artruner-wallet-fund-history";
export const getBookedTicketsDetails = "artrunner/getEventBookingList";
export const getAllBookingList = "artrunner/getAllBookingList";
export const getTicketDetails = "artrunner/getTicketDetails";
export const refundTransaction = "wallet/refund-wallet-transaction";

export const addAdminProcessingFee = "admin/add-Admin-Processing-Fee";
export const updateAdminProcessingFee = "admin/update-Admin-Processing-Fee";
export const toggleAdminProcessingFeeStatus = "admin/active-inactive-Admin-Processing-Fee";
export const getAllAdminProcessingFees = "admin/get-all-Admin-Processing-Fees";
export const getAllExchangeRates = "wallet/get-allExchangeRate";
export const getAllCities = "location/cities";
export const getAllStates = "location/states";
export const getAllConries = "location/countries";


export const postArtCancel = "admin/admin-by-cancel-art-runner-event";
